import Anonymous from './anonymous-400.png';
import Ayurveda from './ayurveda.jpg';
import Banner from './banner.jpg';
import Blog1 from './blog1.jpg';
import Blog2 from './blog2.jpg';
import Blog3 from './blog3.jpg';
import Doctor from './dr-400-4.jpg';
import Test1 from './test1.jpeg';
import Test2 from './Test2.svg.png';
import Test3 from './test3.jpeg';
import Test4 from './Test4.jpeg';
import User from './user-400-2.jpg';
import Vhealthy from './vhealthylogo.png';
import Vhealthy2 from './vHearlthy2.png';
import Yoga from './yoga-purple.jpg';
import RegisterPage from './register.png';
import Lotus from './Lotus.png';
import AlternativeFirst from './sgd/odd-3-en.png';
import AlternativeSecond from './Capture2.png';
import AlternativeThird from './Rectangle 7.png';
import AlternativeFour from './Rectangle 8.png';
import AlternativeFive from './Rectangle 9.png';
import AlternativeSix from './Frame 1.png';
import AlternativeSeven from './Rectangle 2.png';
import AlternativeEight from './Rectangle 3.png';
import AlternativeNine from './Group 14.png';
import AlternativeTen from './Frame 6.png';
import AlternativeEleven from './Frame 7.png';
import AlternativeTweleve from './Frame 8.png';
import AlternativeThirteen from './Frame 9.png';
import AlternativeFourteen from './Frame 10.png';
import AlternativeFifteen from './Rectangle 10.png';
import Language from './language.png';
import VerifiedTraining from './Verified training.png';
import Peers from './peers.png';
import ExpertsInField from './experts in field.png';
import Consultant from './Consultant.png';
import Client from './Client.png';
import digitalProductHeader from './digitalProductHeader.png';
import AuthBg from './Rectangle 56.png';
import AuthBg2 from './Rectangle 57.png';
import AuthBg3 from './Rectangle 58.png';
import AuthBg4 from './Rectangle 59.png';
import AuthBg5 from './Rectangle 49.png';

import SDGFirst from './Group 11.png';
import SDGSecond from './Group 15.png';

import SDGFirstEn from './sgd/odd-3-en.png';
import SDGSecondEn from './sgd/odd-5-en.png';
import SDGThirdEn from './sgd/odd-8-en.png';
import SDGFourEn from './sgd/odd-9-en.png';
import SDGFiveEn from './sgd/odd-10-en.png';
import SDGSixEn from './sgd/odd-16-en.png';
import SDGFirstFr from './sgd/odd-3-fr.png';
import SDGSecondFr from './sgd/odd-5-fr.png';
import SDGThirdFr from './sgd/odd-8-fr.png';
import SDGFourFr from './sgd/odd-9-fr.png';
import SDGFiveFr from './sgd/odd-10-fr.png';
import SDGSixFr from './sgd/odd-16-fr.png';



export {
    digitalProductHeader,
    VerifiedTraining,
    Test4,
    ExpertsInField,
    Consultant,
    Client,
    Test1,
    Test2,
    Test3,
    Language,
    AlternativeFirst,
    AlternativeSecond,
    AlternativeThird,
    AlternativeFour,
    AlternativeFive,
    AlternativeSix,
    AlternativeSeven,
    AlternativeEight,
    AlternativeNine,
    AlternativeTen,
    AlternativeEleven,
    AlternativeTweleve,
    AlternativeThirteen,
    AlternativeFourteen,
    AlternativeFifteen,
    Anonymous,
    Ayurveda,
    Banner,
    Blog1,
    Blog2,
    Blog3,
    Doctor,
    Peers,
    User,
    Vhealthy,
    Vhealthy2,
    RegisterPage,
    Yoga,
    Lotus,
    AuthBg,
    AuthBg2,
    AuthBg3,
    AuthBg4,
    AuthBg5,

    SDGFirstEn,
    SDGSecondEn,
    SDGThirdEn,
    SDGFourEn,
    SDGFiveEn,
    SDGSixEn,
    SDGFirstFr,
    SDGSecondFr,
    SDGThirdFr,
    SDGFourFr,
    SDGFiveFr,
    SDGSixFr,
    SDGFirst,
    SDGSecond,

};
